export default {
  placeholder: 'Select a tag',
};
